import { Injectable } from '@angular/core';
import { CanLoad, Route, UrlSegment } from '@angular/router';
import { Observable } from 'rxjs';
import { LDFlagsService } from '@dg/shared-services';

@Injectable()
export class OnboardingModuleLoadGuardService implements CanLoad {
  constructor(private ldFlagsService: LDFlagsService) {}

  canLoad(
    route: Route,
    segments: UrlSegment[]
  ): Observable<boolean> | Promise<boolean> | boolean {
    if (this.ldFlagsService.skills.july2024MajorRelease) {
      return import('../../onboarding/onboarding.module').then((m) => {
        route.loadChildren = () => Promise.resolve(m.OnboardingModule);
        return true;
      });
    } else {
      return import('../../onboarding-old/onboarding.module').then((m) => {
        route.loadChildren = () => Promise.resolve(m.OnboardingModule);
        return true;
      });
    }
  }
}
